module.exports = __webpack_public_path__ + "img/img_works15.6ee5f8a2.jpg";